var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0006 29.9962C7.76025 29.9962 9.99997 27.7565 9.99997 24.9969V19.9975H5.0006C2.24094 19.9975 0.0012207 22.2372 0.0012207 24.9969C0.0012207 27.7565 2.24094 29.9962 5.0006 29.9962Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0012207 14.9981C0.0012207 12.2384 2.24094 9.99872 5.0006 9.99872H9.99997V19.9975H5.0006C2.24094 19.9975 0.0012207 17.7577 0.0012207 14.9981Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0012207 4.99937C0.0012207 2.23972 2.24094 0 5.0006 0H9.99997V9.99875H5.0006C2.24094 9.99875 0.0012207 7.75903 0.0012207 4.99937Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 0H14.9991C17.7588 0 19.9985 2.23972 19.9985 4.99937C19.9985 7.75903 17.7588 9.99875 14.9991 9.99875H9.99976V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9985 14.9981C19.9985 17.7577 17.7588 19.9975 14.9991 19.9975C12.2395 19.9975 9.99976 17.7577 9.99976 14.9981C9.99976 12.2384 12.2395 9.99872 14.9991 9.99872C17.7588 9.99872 19.9985 12.2384 19.9985 14.9981Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 29.9962,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject1Icon);
export default __webpack_public_path__ + "static/media/project-1-icon.be6eb5c0623d0ba1b04b3a1856b6cd9e.svg";
export { ForwardRef as ReactComponent };